EmailConfirmationNewCtrl = ($scope, $filter, $translate, flash, account, EmailConfirmationService) ->
  $scope.originalEmail = account.email
  $scope.lang = $translate.use()
  $scope.openPositiveConfirmation = false

  $scope.send_confirmation_email = ->
    EmailConfirmationService.send()
      .then (resp) ->
        $scope.emailSent = true
        flash.success $filter('translate')('_CONFIRMATION.NEW.EMAIL_SENT')
      .catch (error) ->
        flash.error $filter('translate')('_ERROR_HANDLER.UNEXPECTED_ERROR_MSG')

  $scope.toggle_positive_confirmation = ->
    $scope.openPositiveConfirmation = !$scope.openPositiveConfirmation


EmailConfirmationNewCtrl.$inject = [
  '$scope'
  '$filter'
  '$translate'
  'flash'
  'account'
  'EmailConfirmationService'
]

module.exports = EmailConfirmationNewCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/email-confirmation/new-controller.coffee